import config from "@/config"
import http from "@/utils/request"

export default {
    getAttendanceRecordListAPI: {
        url: `${config.API_URL}/attendanceRecord/`,
        name: "查询打卡记录列表",
        get: async function(data) {
            return await http.get(this.url, data)
        }
    },
    addAttendanceRecordAPI: {
        url: `${config.API_URL}/attendanceRecord/`,
        name: "新增打卡记录",
        post: async function(data) {
            return await http.post(this.url, data)
        }
    }
}
